// components/LegalRepresentatives/RepresentativesFilters.js
/**
 * Composant pour la barre de filtres des représentants légaux
 * @param {Object} props - Propriétés du composant
 * @param {Object} props.filters - Filtres actuels
 * @param {Function} props.onFiltersChange - Fonction pour mettre à jour les filtres
 * @param {boolean} props.loading - État de chargement
 */
const RepresentativesFilters = ({ filters, onFiltersChange, loading }) => {
  /**
   * Gérer le changement de valeur d'un filtre
   * @param {string} filterName - Nom du filtre
   * @param {any} value - Nouvelle valeur du filtre
   */
  const handleFilterChange = (filterName, value) => {
    onFiltersChange({ [filterName]: value });
  };

  /**
   * Réinitialiser tous les filtres
   */
  const handleResetFilters = () => {
    onFiltersChange({
      search: '',
      hasManagedAccounts: null,
      sortBy: 'ManagedAccountsCount',
      sortOrder: 'desc',
      page: 1
    });
  };

  return (
    <div className="card mb-4 border-0 shadow-sm">
      <div className="card-body">
        <div className="row g-3 align-items-end">
          {/* Recherche texte */}
          <div className="col-md-3">
            <div className="input-group">
              <input
                id="searchInput"
                type="text"
                className="search-input"
                placeholder="Nom, email..."
                value={filters.search}
                onChange={(e) => handleFilterChange('search', e.target.value)}
                disabled={loading}
              />
            </div>
          </div>

          {/* Filtre comptes gérés */}
          <div className="col-md-2">
            <select
              id="managedAccountsFilter"
              className="account-type-select"
              value={filters.hasManagedAccounts ?? ''}
              onChange={(e) => handleFilterChange('hasManagedAccounts', e.target.value === '' ? null : e.target.value === 'true')}
              disabled={loading}
            >
              <option value="">Tous</option>
              <option value="true">Avec comptes gérés</option>
              <option value="false">Sans comptes gérés</option>
            </select>
          </div>

          {/* Tri par */}
          <div className="col-md-2">
            <select
              id="sortByFilter"
              className="account-type-select"
              value={filters.sortBy}
              onChange={(e) => handleFilterChange('sortBy', e.target.value)}
              disabled={loading}
            >
              <option value="ManagedAccountsCount">Comptes gérés</option>
              <option value="LastName">Nom</option>
              <option value="CreationDate">Date création</option>
              <option value="LastMandateDate">Dernier mandat</option>
            </select>
          </div>

          {/* Ordre de tri */}
          <div className="col-md-2">
            <select
              id="sortOrderFilter"
              className="account-type-select"
              value={filters.sortOrder}
              onChange={(e) => handleFilterChange('sortOrder', e.target.value)}
              disabled={loading}
            >
              <option value="desc">Ordre</option>
              <option value="desc">Décroissant</option>
              <option value="asc">Croissant</option>
            </select>
          </div>

          {/* Bouton réinitialiser */}
          <div className="col-md-2">
            {/* <div className="d-flex justify-content-between align-items-center"> */}
              <button
                type="button"
                className="filter-button"
                onClick={handleResetFilters}
                disabled={loading}
              >
                <i className="fas fa-refresh me-1"></i>
                Réinitialiser
              </button>
            {/* </div> */}
          </div>

          <div className="col-md-1">
            {/* Indicateur de filtres actifs */}
            {(filters.search || filters.hasManagedAccounts !== null) && (
              <small className="text-muted">
                Filtres actifs • 
                <button 
                  className="filter-button"
                  onClick={handleResetFilters}
                >
                  Tout effacer
                </button>
              </small>
            )}
          </div>
        </div>
      </div>
    </div>

  );
};

export default RepresentativesFilters;